<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10.111 2.48145L9.78969 7.67964C9.70759 9.00775 9.66654 9.67181 9.33364 10.1492C9.16905 10.3853 8.95715 10.5845 8.71139 10.7342C8.21435 11.037 7.54902 11.037 6.21838 11.037C4.88598 11.037 4.21978 11.037 3.72239 10.7336C3.47648 10.5836 3.26451 10.3841 3.09998 10.1477C2.76719 9.66946 2.72704 9.00447 2.64675 7.67449L2.33325 2.48145"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M1.55566 2.48181H10.889M8.3253 2.48181L7.97132 1.75159C7.73618 1.26653 7.61862 1.024 7.41581 0.872743C7.37083 0.839192 7.32319 0.809348 7.27338 0.783504C7.0488 0.666992 6.77928 0.666992 6.24023 0.666992C5.68765 0.666992 5.41136 0.666992 5.18306 0.788388C5.13246 0.815293 5.08417 0.846346 5.03871 0.881227C4.83355 1.03861 4.71895 1.29002 4.48976 1.79283L4.1757 2.48181"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M4.92603 8.18555L4.92603 5.07444"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M7.51855 8.18533L7.51855 5.07422"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
